export default "__VITE_ASSET__5H9J3pUp__"